import { createTheme } from '@mui/material/styles';
import transitions from './transition.js';
import palette from './palette-light.js';
import typography from './typography.js';

const lightTheme = createTheme({
    palette,
    transitions,
    typography,
    spacing: 4,
});

export { lightTheme as default };
//# sourceMappingURL=lightTheme.js.map
